var map = {
	"./aaveg.png": 57264,
	"./abhinav.png": 31843,
	"./aditya.png": 13212,
	"./ankit.jpeg": 61736,
	"./anshika.png": 52805,
	"./ayushi.jpeg": 6446,
	"./datacode.png": 13773,
	"./dhanushka.svg": 22951,
	"./gopal.png": 89417,
	"./ishaan.png": 35258,
	"./jayesh.png": 92618,
	"./ketki.png": 95436,
	"./manas.png": 10356,
	"./mrinal.png": 63893,
	"./rajan.png": 24354,
	"./rajeev.png": 43375,
	"./sai.png": 61209,
	"./shubhangi.png": 3745,
	"./sonakshi.png": 84776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65776;